import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const AppCard = ({ app, index = 0 }) => {
  const soon = app.status === "coming-soon";
  return (
    <motion.article
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/apps/${app.slug}`}
        data-testid={`app-card-${app.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-3xl p-6 transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1.5 sm:p-8"
        style={{ background: "var(--surface)", border: "1px solid var(--line)" }}
      >
        <span
          aria-hidden
          className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-0 blur-2xl transition-opacity duration-700 group-hover:opacity-40"
          style={{ background: app.accent }}
        />
        <div className="relative flex items-start justify-between gap-4">
          <img
            src={app.icon}
            alt={`${app.name} app icon`}
            loading="lazy"
            className="h-16 w-16 rounded-2xl object-cover sm:h-20 sm:w-20"
            style={{ border: "1px solid var(--line)" }}
          />
          <span
            className="rounded-full px-3 py-1 font-mono-x text-[10px] uppercase tracking-[0.16em]"
            style={{
              color: soon ? "#9CA3AF" : app.accent,
              border: `1px solid ${soon ? "var(--line)" : app.accent + "66"}`,
            }}
          >
            {soon ? "Coming soon" : "Available"}
          </span>
        </div>

        <h3 className="font-display mt-7 text-xl font-bold tracking-tight text-white sm:text-2xl">
          {app.name}
        </h3>
        <p className="mt-1 font-mono-x text-xs text-gray-500">{app.category}</p>
        <p className="mt-4 flex-1 text-sm leading-relaxed text-gray-400">{app.shortDescription}</p>

        <div className="mt-7 flex items-center justify-between">
          <div className="flex gap-2">
            {app.platforms.map((p) => (
              <span
                key={p}
                className="rounded-md px-2 py-1 text-[11px] text-gray-400"
                style={{ background: "var(--surface-2)" }}
              >
                {p}
              </span>
            ))}
          </div>
          <span
            className="flex h-9 w-9 items-center justify-center rounded-full transition-[background-color,color] duration-500 group-hover:bg-white group-hover:text-[#08090d]"
            style={{ border: "1px solid var(--line)" }}
            aria-hidden
          >
            <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </Link>
    </motion.article>
  );
};
